import { render, staticRenderFns } from "./img-dialog.vue?vue&type=template&id=0350b7be&scoped=true&"
import script from "./img-dialog.vue?vue&type=script&lang=js&"
export * from "./img-dialog.vue?vue&type=script&lang=js&"
import style0 from "./img-dialog.vue?vue&type=style&index=0&id=0350b7be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0350b7be",
  null
  
)

export default component.exports